<template>
  <div>
    <label v-if="label" :for="label" class="block text-sm leading-5 font-medium text-gray-700"
      >{{ label }} <span v-if="optional" class="text-xs text-gray-700">(optional)</span></label
    >
    <div class="mt-1 relative">
      <input
        :id="label"
        autocomplete="off"
        type="time"
        class="formkit-input block w-full bg-white rounded-md border border-gray-300 focus:border-blue-500 focus:ring-blue-500 sm:text-sm px-3 py-2 min-h-[38px] field-sizing-fixed"
        :placeholder="placeholder"
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: String,
    label: {
      type: String,
      default: '',
    },
    placeholder: String,
    optional: Boolean,
  },
  emits: ['update:modelValue'],
};
</script>

<style scoped>
input[type='time'] {
  min-width: 140px;
}
</style>
